import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import Grid from '@material-ui/core/Grid';
import Header from '../../../../common/sasl/models/Header';
import QuickView from '../../common/drawer/QuickView';
import ViewEditBatchItem from '../updateBatch/ViewEditBatch';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='down' ref={ref} {...props} />;
});

const UpdateBatch = (props) => {
  const { open, handleClose, qaApproval } = props;
  // Define isApprovedButton internally based on qaApproval
  const isApprovedButton = true; // true if qaApproval is true, false otherwise

  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <QuickView setDialogOpen={handleClose} isApprovedButton={isApprovedButton} {...props} />
          </Grid>
        </Grid>
      </Dialog>
    </React.Fragment>
  );
};

export default UpdateBatch;